<template>
  <section>
    <div class="popups">
      <b-sidebar
        v-model="showFilters"
        right
        shadow
        backdrop
        bg-variant="white"
        no-header
      >
        <template #default="{ hide }">
          <div class="container sidebar-header">
            <b-row>
              <div class="col">
                <b-button
                  variant="primary"
                  @click="
                    applyFilters();
                    loadItems();
                    showFilters = false;
                  "
                  >Apply</b-button
                >
              </div>
              <div class="col-auto text-right">
                <b-button variant="link" class="ml-3 px-0" @click="hide">
                  <i class="fa fa-times"></i>
                </b-button>
              </div>
            </b-row>
          </div>

          <div class="px-3 py-2">
            <b-form-group label="Client:">
              <b-v-select
                v-model="formFilters.brandId"
                :searchable="true"
                :options="brandsFilter"
              />
            </b-form-group>
            <b-form-group label="Warehouse:">
              <b-v-select
                v-model="formFilters.warehouseId"
                :searchable="true"
                :options="warehousesFilter"
              />
            </b-form-group>
            <b-form-group label="Name:">
              <b-form-input v-model="formFilters.name" />
            </b-form-group>
            <b-form-group label="Item Sku:">
              <b-form-input v-model="formFilters.sku" />
            </b-form-group>
          </div>
        </template>
      </b-sidebar>
    </div>

    <div class="header">
      <div class="header-body">
        <div class="row align-items-end">
          <div class="col">
            <h1 class="header-title">
              Changelog
            </h1>
          </div>
          <div class="col-auto">
            <router-link
              :to="{ name: 'Admin.Changelog.Create' }"
              class="btn btn-success"
            >
              <i class="mr-2 fa fa-plus" />
              Add New
            </router-link>

            <!-- <b-button
              variant="primary"
              class="ml-2"
              @click="showFilters = !showFilters"
            >
              <i class="fa fa-filter mr-2"></i>
              Filters
            </b-button> -->
          </div>
        </div>
      </div>
    </div>

    <TableListing
      class="mb-0"
      :loading-page="loadingItems"
      :failed-loading="failedLoadItems"
      head-variant="dark"
      :items.sync="items"
      :fields.sync="fields"
      :pagination.sync="pagination"
      :options.sync="tableOptions"
      v-on:pagination-changed="loadItems"
    >
      <template v-slot:cell(id)="data">
        <div class="d-flex">
          <router-link class="btn btn-primary mr-1" :to="{
              name: 'Admin.Changelog.Edit',
              params: { id: data.item.id }
            }">
            Edit
          </router-link>
        </div>
      </template>
      <template v-slot:cell(createDateTimeUtc)="data">
        <span
          v-if="
            data.item.createDateTimeUtc &&
              !data.item.createDateTimeUtc.endsWith('Z')
          "
          >{{
            (data.item.createDateTimeUtc + 'Z') | moment('MMM Do YY, h:mm a')
          }}</span
        >
        <span v-else-if="data.item.createDateTimeUtc">{{
          data.item.createDateTimeUtc | moment('MMM Do YY, h:mm a')
        }}</span>
      </template>
      <template v-slot:cell(name)="data">
        <span>{{ data.item.name }}</span>
      </template>
    </TableListing>
  </section>
</template>

<script>
import TableListing from '@/views/components/TableListing.vue';
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  name: 'Admin.Changelog.Index',
  mixins: [crudMixinGen('docs/changelog'), myCommonDataMixin],
  components: {
    TableListing
  },

  data: () => ({
    fields: [
      { key: 'name', label: 'Update', sortable: false },
      { key: 'createDateTimeUtc', label: 'Created At', sortable: true },
      { key: 'id', label: 'Actions', sortable: false }
    ]
  }),
  computed: {
  },

  mounted() {
    this.loadItems();
  },

  methods: {

  }
};
</script>
